<app-loading
  [loading] = loading
></app-loading>

<ng-container *ngIf="!isModal">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <div class="content-wrapper">
    <section class="content">
      <app-breadcrumb
        Titulo="Detalhes atendimento"
        Pagina="Detalhes"
        [TemPaginaPai] = true
        LinkPaginaPai="/cadastro/atendimento"
        PaginaPai="Atendimentos"
      ></app-breadcrumb>
      <div class="row">
        <div class="col-md-12">
          <div class="card" style="min-height: 500px">
            <div class="card-body" >
              <ng-container [ngTemplateOutlet]="detalhesTemplate"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<div class="modal-overlay" *ngIf="isModal && showModal" (click)="!loading && fecharModal()">
  <div class="box-atendimento-detalhes" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">Detalhes do Atendimento</h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <ng-container [ngTemplateOutlet]="detalhesTemplate"></ng-container>
    </div>
  </div>
</div>

<ng-template #detalhesTemplate>
  <div class="row">
    <div class="col-md-3" *ngIf="!isModal" style="border-right: 1px #4973cf solid;min-height: 500px; padding-right: 50px; ">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title text-blue">Opções</h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fa fa-minus text-blue"></i>
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <ul class="nav nav-pills flex-column">
            <li class="nav-item active">
              <a class="nav-link">
                <i class="fa fa-edit text-blue" style="margin-right: 8px"></i>  Alterar dados
              </a>
            </li>
            <li class="nav-item"  (click)="voltar()">
              <a  class="nav-link">
                <i class="fa fa-backward text-danger" style="margin-right: 8px"></i>  Voltar
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div [ngClass]="isModal ? 'col-md-12' : 'col-md-9'">
      <div class="row">
        <div class="col-md-12"><h2 class="text-blue">Atendimento: {{atendimento.descricaoResumida}}</h2></div>
        <div [ngClass]="isModal ? 'col-md-6' : 'col-md-3'">Data: <b>{{atendimento.dataCadastro | date:"dd-MM-yyyy" }}</b></div>
        <div [ngClass]="isModal ? 'col-md-6' : 'col-md-3'">Solicitante: <b>{{atendimento.nomeSolicitante}}</b></div>
        <div [ngClass]="isModal ? 'col-md-6' : 'col-md-3'">Contato: <b>{{atendimento.telefoneSolicitante}}</b></div>
      </div>
      <hr class="col-md-11">
      <div class="row">
        <form id="formAlterarDados" class="col-md-12" [formGroup]="formAlterarDados">
          <div class="row" style="margin-top: 30px" >
            <h4 class="col-md-12">Alterar dados</h4>

            <div class="form-group col-md-12">
              <label for="descricao">Descrição Resumida</label>
              <input
                type="text"
                class="form-control"
                formControlName="descricao"
                id="descricao"
              >
            </div>

            <div class="form-group col-md-12">
              <label for="descricaoInicialDetalhes">Descrição</label>
              <angular-editor id="descricaoInicialDetalhes"
                              [config]="editorConfig"
                              formControlName="descricaoInicial"></angular-editor>
            </div>

          </div>
          <div class="row">
            <div class="col-md-6"><button (click)="voltar()" class="btn btn-light" [ngClass]="isModal ? 'w-100' : 'col-md-4'">Voltar</button></div>
            <div class="col-md-6 text-right">

              <button (click)="salvarAlteracoes()" class="btn btn-primary" [ngClass]="isModal ? 'w-100' : 'col-md-4'">Salvar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>
